<span>
    {{ ("LOCATION" | translate) + " " }}
    <a
    (click)="openLocation($safeNavigationMigration(log?.details?.targetId), $event)"
    style="cursor: pointer; text-decoration: underline; color: #007bff;"
  >
    {{ $safeNavigationMigration(log?.details?.targetName) | identityFormat : $safeNavigationMigration(log?.details?.targetId) }}
  </a>
      
    {{ " " + ("WAS_MODIFIED_BY" | translate) + " " }}
  
    <strong *ngIf="!log?.staffId && log?.staffName === 'Everon Admin'; else elseBlock">
      Everon Admin
    </strong>
  
    <ng-template #elseBlock>
      <a [routerLink]="['/staff', $safeNavigationMigration(log?.staffId)]" (click)="closeDialog.emit()">
        {{ $safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId) }}
      </a>
    </ng-template>
  </span>
  
  <p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>
  
  <hr />

  <div class="container">

    <!-- Name -->
    <ng-container *ngIf="visibleFields | includes : 'name'">
      <span class="item-title">{{ "NAME" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.name?.oldValue || ('NONE' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.name?.newValue || ('NONE' | translate) }}
        </span>
      </div>
    </ng-container>

    <!-- Qualifier-->
    <!-- <ng-container *ngIf="visibleFields | includes : 'qualifier'">
      <span class="item-title">{{ "QUALIFIER" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.qualifier?.oldValue || ('NONE' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.qualifier?.newValue || ('NONE' | translate) }}
        </span>
      </div>
    </ng-container> -->

     <!-- Contact phone -->
     <ng-container *ngIf="visibleFields | includes : 'contactPhone'">
      <span class="item-title">{{ "CONTACT_PHONE" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.contactPhone?.oldValue || ('NONE' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.contactPhone?.newValue || ('NONE' | translate) }}
        </span>
      </div>
    </ng-container>
  
    <!-- Address -->
    <ng-container *ngIf="visibleFields | includes : 'address'">
      <span class="item-title">{{ "ADDRESS" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.address?.oldValue || ('NONE' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.address?.newValue || ('NONE' | translate) }}
        </span>
      </div>
    </ng-container>
  
    <!-- PostCode -->
    <ng-container *ngIf="visibleFields | includes : 'postCode'">
      <span class="item-title">{{ "POSTCODE" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.postCode?.oldValue || ('NONE' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.postCode?.newValue || ('NONE' | translate) }}
        </span>
      </div>
    </ng-container>
  
    <!-- PostOffice -->
    <ng-container *ngIf="visibleFields | includes : 'postOffice'">
      <span class="item-title">{{ "POSTOFFICE" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.postOffice?.oldValue || ('NONE' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.postOffice?.newValue || ('NONE' | translate) }}
        </span>
      </div>
    </ng-container>
  
    <!-- MainUserGsmNumber -->
    <ng-container *ngIf="visibleFields | includes : 'mainUserGsmNumber'">
      <span class="item-title">{{ "MAIN_USER_GSM" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.mainUserGsmNumber?.oldValue || ('NONE' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.mainUserGsmNumber?.newValue || ('NONE' | translate) }}
        </span>
      </div>
    </ng-container>
  
    <!-- Boolean fields -->
    <ng-container *ngIf="visibleFields | includes : 'emaTagOnly'">
      <span class="item-title">{{ "EMA_TAG_ONLY" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.emaTagOnly?.oldValue ? ('true' | translate) : ('false' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.emaTagOnly?.newValue ? ('true' | translate) : ('false' | translate) }}
        </span>
      </div>
    </ng-container>
  
    <ng-container *ngIf="visibleFields | includes : 'networkFailureState'">
      <span class="item-title">{{ "NETWORK_FAILURE_STATE" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ locationChanges.networkFailureState?.oldValue ? ('true' | translate) : ('false' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ locationChanges.networkFailureState?.newValue ? ('true' | translate) : ('false' | translate) }}
        </span>
      </div>
    </ng-container>

      
    <!-- Personnel list access rights -->
    <!-- Added personnels -->
    <ng-container *ngIf="visiblePersonnelFields.includes('addedPersonnels')">
        <span class="item-title">{{ "ADDED_ACCESS_RIGHTS" | translate }}:</span>
        <div class="item-pair-value">
        <span class="positive-highlight">
            <ng-container *ngFor="let personnel of personnelChanges.addedPersonnels">
                {{ personnelNames[personnel] }}
            <br />
            </ng-container>
        </span>
        </div>
    </ng-container>
    
    <!-- Removed personnels -->
    <ng-container *ngIf="visiblePersonnelFields.includes('removedPersonnels')">
        <span class="item-title">{{ "REMOVED_ACCESS_RIGHTS" | translate }}:</span>
        <div class="item-pair-value">
        <span class="negative-highlight line-through">
            <ng-container *ngFor="let personnel of personnelChanges.removedPersonnels">
                {{ personnelNames[personnel] }}
            <br />
            </ng-container>
        </span>
        </div>
    </ng-container>
  
  <!-- EMA Settings Changes -->  
  <ng-container *ngFor="let field of visibleEmaFields">
  <!-- ALERT TIMERS -->
      <!-- RESERVED -->
  <ng-container *ngIf="field === 'reserved'">
    <span class="item-title">{{ "RESERVED_TIMEOUT" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ getMinuteValue('reserved', emaChanges.oldSettings) ?? ('NONE' | translate) }}
        {{ 'MINUTES' | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ getMinuteValue('reserved', emaChanges.newSettings) ?? ('NONE' | translate) }}
        {{ 'MINUTES' | translate }}
      </span>
    </div>
  </ng-container>

  <!-- STARTED -->
  <ng-container *ngIf="field === 'started'">
    <span class="item-title">{{ "STARTED_TIMEOUT" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ getMinuteValue('started', emaChanges.oldSettings) ?? ('NONE' | translate) }}
        {{ 'MINUTES' | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ getMinuteValue('started', emaChanges.newSettings) ?? ('NONE' | translate) }}
        {{ 'MINUTES' | translate }}
      </span>
    </div>
  </ng-container>

  <!-- COMPLETED -->
  <ng-container *ngIf="field === 'completed'">
    <span class="item-title">{{ "COMPLETED_TIMEOUT" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ getMinuteValue('completed', emaChanges.oldSettings) ?? ('NONE' | translate) }}
        {{ 'MINUTES' | translate }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ getMinuteValue('completed', emaChanges.newSettings) ?? ('NONE' | translate) }}
        {{ 'MINUTES' | translate }}
      </span>
    </div>
  </ng-container>

  <!-- PRIORITIES -->
  <ng-container *ngFor="let p of getAlertPrioritiesDisplay()">
    <!-- Sound/Colour changes -->
    <ng-container *ngIf="p.oldSound !== p.newSound || p.oldColour !== p.newColour">
      <span class="item-title">
        {{ "PRIORITY" | translate }} {{ p.priority }}:
      </span>

      <div class="details-box">
      <div class="flex flex-col gap-1">
        <ng-container *ngIf="p.oldSound !== p.newSound">
          <div class="item-pair-value">
            <span class="negative-highlight line-through">{{ p.oldSound | translate }}</span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">{{ p.newSound | translate }}</span>
          </div>
        </ng-container>
      </div>

        <ng-container *ngIf="p.oldColour !== p.newColour">
          <div class="item-pair-value">
            <span class="negative-highlight line-through">{{ p.oldColour | translate }}</span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">{{ p.newColour | translate }}</span>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <!-- Moved types  -->
  <ng-container *ngFor="let move of getPriorityMoveGroups()">
    <span class="item-title">
      {{ "PRIORITY" | translate }} {{ move.fromPriority }} → {{ "PRIORITY" | translate }} {{ move.toPriority }}:
    </span>
    <div class="item-pair-value flex items-center gap-2">
      <span class="positive-highlight">
        {{ getTranslatedTypes(move.types) }}
      </span>
    </div>
  </ng-container>

   <!-- ALERT OPTIONS -->
    <ng-container *ngIf="field === 'offlineDelay'">
      <span class="item-title">{{ 'OFFLINE_DELAY' | translate }}:</span>
      <div class="item-pair-value">

        <span class="negative-highlight line-through">
          <ng-container *ngIf="isNumeric(getEmaValue('offlineDelay', emaChanges.oldSettings)); else oldOption">
            {{ getMinuteValue('offlineDelay', emaChanges.oldSettings) }} {{ 'MINUTES' | translate }}
          </ng-container>
          <ng-template #oldOption>
            {{ getEmaTranslation('offlineDelay', getEmaValue('offlineDelay', emaChanges.oldSettings)) }}
          </ng-template>
        </span>

        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          <ng-container *ngIf="isNumeric(getEmaValue('offlineDelay', emaChanges.newSettings)); else newOption">
            {{ getMinuteValue('offlineDelay', emaChanges.newSettings) }} {{ 'MINUTES' | translate }}
          </ng-container>
          <ng-template #newOption>
            {{ getEmaTranslation('offlineDelay', getEmaValue('offlineDelay', emaChanges.newSettings)) }}
          </ng-template>
        </span>
      </div>
    </ng-container>
    
    <!-- STARTED_TASK_MUTING -->
    <ng-container *ngIf="field === 'startedTaskMuting'">
      <span class="item-title">{{ 'STARTED_TASK_MUTING' | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ getEmaValue('startedTaskMuting', emaChanges.oldSettings) | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ getEmaValue('startedTaskMuting', emaChanges.newSettings) | translate }}
        </span>
      </div>
    </ng-container>
      <!-- MINIMUM_VOLUME -->
      <ng-container *ngIf="field === 'minimumVolume'">
        <span class="item-title">{{ 'MINIMUM_VOLUME' | translate }}:</span>
        <div class="item-pair-value">
          <span class="negative-highlight line-through">
            {{ getMinuteValue('minimumVolume', emaChanges.oldSettings) ?? ('NONE' | translate) }}%
          </span>
          <i class="fa-light fa-arrow-right-long fa-lg"></i>
          <span class="positive-highlight">
            {{ getMinuteValue('minimumVolume', emaChanges.newSettings) ?? ('NONE' | translate) }}%
          </span>
        </div>
      </ng-container>

  <!-- Added notes -->
  <ng-container *ngIf="getAddedNotes().length">
      <span class="item-title">{{ "ADDED_NOTES" | translate }}:</span>
      <div class="item-pair-value">
        <span class="positive-highlight">
          <ng-container *ngFor="let note of getAddedNotes()">
            {{ note }}
            <br />
          </ng-container>
        </span>
      </div>
    </ng-container>
  
  <!-- Removed notes -->
  <ng-container *ngIf="getRemovedNotes().length">
    <span class="item-title">{{ "REMOVED_NOTES" | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        <ng-container *ngFor="let note of getRemovedNotes()">
          {{ note }}
          <br />
        </ng-container>
      </span>
    </div>
  </ng-container>

  <!-- USER INTERFACE -->
     <!-- Quick complete -->
     <ng-container *ngIf="field === 'quickComplete'">
      <span class="item-title">{{ 'QUICK_ALERT_COMPLETE' | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ getEmaValue('quickComplete', emaChanges.oldSettings) | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ getEmaValue('quickComplete', emaChanges.newSettings) | translate }}
        </span>
      </div>
    </ng-container>

       <!-- Alert card -->
       <ng-container *ngIf="field === 'alertCardHeader'">
        <span class="item-title">{{ 'ALERT_CARD_HEADER' | translate }}:</span>
        <div class="item-pair-value">
          <span class="negative-highlight line-through">
            {{ getEmaValue('alertCardHeader', emaChanges.oldSettings) | translate }}
          </span>
          <i class="fa-light fa-arrow-right-long fa-lg"></i>
          <span class="positive-highlight">
            {{ getEmaValue('alertCardHeader', emaChanges.newSettings) | translate }}
          </span>
        </div>
      </ng-container>

   <!-- LOGIN KEYS -->
   <ng-container *ngIf="field === 'value'">
    <span class="item-title">{{ 'LOGIN_KEYS' | translate }}:</span>
    <div class="item-pair-value">
      <span class="negative-highlight line-through">
        {{ getEmaTranslation(field, getEmaValue(field, emaChanges.oldSettings)) }}
      </span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">
        {{ getEmaTranslation(field, getEmaValue(field, emaChanges.newSettings)) }}
      </span>
    </div>
  </ng-container>